import salesDataConstants from "../constants/salesDataContants";

export const mapData = (payload: any[], index: number, mappedTo: string) => ({
  type: salesDataConstants.COLUMN_MAP_REQUEST,
  payload,
  index,
  mappedTo,
});

export const setFilteredFileCols = (fileCols: string[]) => ({
  type: salesDataConstants.SET_FILTERED_FILE_COLS_REQUEST,
  fileCols,
});

export const getSalesFiles = (payload: any) => ({
  type: salesDataConstants.GET_SALES_FILES_REQUEST,
  payload,
});

export const postSalesFile = (payload: any) => {
  return {
    type: salesDataConstants.POST_SALES_FILE_REQUEST,
    payload,
  };
};

export const getFileColumns = (payload: any) => {
  return {
    type: salesDataConstants.GET_FILE_COLUMNS_REQUEST,
    payload,
  };
};

export const mapSalesDataToRawData = (payload: any) => ({
  type: salesDataConstants.MAP_TO_RAW_DATA_REQUEST,
  payload,
});

export const getMasterData = (payload: any) => ({
  type: salesDataConstants.GET_MASTER_DATA_REQUEST,
  payload,
});

export const editMasterData = (id: string, payload: any) => ({
  type: salesDataConstants.EDIT_MASTER_DATA_REQUEST,
  id,
  payload,
});

export const deleteMasterData = (id: string) => ({
  type: salesDataConstants.DELETE_MASTER_DATA_REQUEST,
  id,
});

export const processMasterData = (payload: any) => ({
  type: salesDataConstants.PROCESS_MASTER_DATA_REQUEST,
  payload,
});

export const deleteSalesFile = (payload: any) => ({
  type: salesDataConstants.DELETE_SALES_FILE_REQUEST,
  payload,
});

export const deleteProcessedFile = (payload: any) => ({
  type: salesDataConstants.DELETE_PROCESSED_FILE_REQUEST,
  payload,
});

export const downloadSalesFile = (payload: any) => ({
  type: salesDataConstants.DOWNLOAD_SALES_FILE_REQUEST,
  payload,
});

export const resetDownloadSalesFile = () => ({
  type: salesDataConstants.RESET_DOWNLOAD_SALES_FILE,
});

export const resetSalesFiles = () => ({
  type: salesDataConstants.RESET_SALES_FILES,
});
